import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  main: {
    width: '28rem',
    height: '4rem',
    color: theme.palette.background.paper,
    borderRadius: '.5rem',
    padding: '1.5rem',
    transition: 'all .2s',
    margin: '1.6rem',
    fontFamily: theme.typography.body2.fontFamily,
    fontWeight: 700,
    fontSize: '1.4rem',
    lineHeight: '1.8rem',
    wordBreak: 'break-all',

    '&:active': {
      transform: 'translateY(.1rem)',
    },

    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  default: {
    background: theme.palette.primary.dark,

    '&:active': {
      transform: 'translateY(.1rem)',
    },

    '&:not(:disabled):hover': {
      background: theme.palette.primary.main,
    },

    '&:disabled': {
      opacity: 1,
      background: '#DAD9D9',
      color: '#919190',
      boxShadow: 'none',
    },
  },
  outlined: {
    background: 'white',
    color: theme.palette.secondary.main,
    border: `.1rem solid ${theme.palette.primary.dark}`,

    '&:not(:disabled):hover': {
      background: '#E1E8E3',
    },

    '& > .MuiTouchRipple-root': {
      color: theme.palette.primary.dark,
    },

    '&:disabled': {
      opacity: 1,
      color: '#A1A19F',
      borderColor: '#DAD9D9',
      boxShadow: 'none',
    },
  },
  labelOnly: {
    background: 'transparent',
    color: theme.palette.secondary.main,
    border: 'none',

    '&:not(:disabled):hover': {
      filter: 'brightness(0.97)',
    },

    '& > .MuiTouchRipple-root': {
      color: theme.palette.primary.main,
    },
  },
  redBorder: {
    border: `.1rem solid ${theme.palette.error.main}`,

    '& > .MuiTouchRipple-root': {
      color: theme.palette.error.main,
    },

    '&:not(:disabled):hover': {
      border: `.1rem solid ${theme.palette.error.main}`,
    },
  },
  filled: {
    background: '#BCE2CB',
    color: theme.palette.primary.dark,

    '&:not(:disabled):hover': {
      filter: 'brightness(0.90)',
    },

    '& > .MuiTouchRipple-root': {
      color: theme.palette.background.paper,
    },

    '&:disabled': {
      opacity: 1,
      background: '#DAD9D9',
      color: '#919190',
      boxShadow: 'none',
    },
  },
  error: {
    background: theme.palette.error.main,
    color: theme.palette.background.paper,

    '&:not(:disabled):hover': {
      filter: 'brightness(0.90)',
    },

    '& > .MuiTouchRipple-root': {
      color: theme.palette.background.paper,
    },

    '&:disabled': {
      opacity: 1,
      background: '#DAD9D9',
      color: '#919190',
      boxShadow: 'none',
    },
  },
}))
